// Team Model
cv.TeamNew = Backbone.RESTModel.extend({
  defaults: {
    name: "",
    stub: "",
    photo_path: "",
    draft: "",
    description: "",
    funds_needed: 0,
    status: "",

    share_auto: "",
    share_title: "",
    share_description: "",
    share_image: "",

    custom_values: {},
  },

  saveMap: {
    name: "name",
    stub: "stub",
    photo_path: "photo_path",
    draft: "draft",
    description: "description",
    funds_needed: "funds_needed",
    status: "status",

    share_auto: "share_auto",
    share_title: "share_title",
    share_description: "share_description",
    share_image: "share_image",

    custom_values: "custom_values",
  },

  urlRoot: function () {
    return cv.new_api_path + "/teams";
  },

  initialize: function () {
    console.log("Team model initialized.");
  },
});
Cocktail.mixin(cv.TeamNew, cv.mixins.SyncModel);

// Teams Collection
cv.TeamsNew = Backbone.Collection.extend({
  initialize: function (options) {
    console.log("Teams collection initialized.");
  },

  url: function () {
    return cv.new_api_path + "/teams?" + $.param(this.params);
  },

  model: cv.TeamNew,
});
Cocktail.mixin(cv.TeamsNew, cv.mixins.PaginateModel);
